const styles = () => ({
  infoList: {
    padding: 0,
    marginTop: 20,
    display: 'flex',
    overflowWrap: 'anywhere',
  },
  alert: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    '& .MuiAlert-icon': {
      height: 20,
    },
  },
  message: {
    width: '100%',
    padding: 0,
  },
  accordion: {
    background: 'none',
    boxShadow: 'none',
    border: 'none',
  },
  dropInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    cursor: 'pointer',
  },
  '@media (max-width: 400px)': {
    alert: {
      padding: '6px',
    },
    info: {
      fontSize: '14px',
    },
  },
})

export default styles
